// extracted by mini-css-extract-plugin
module.exports = {"item":"Food_item__1a5ZO","question":"Food_question__1YBK3","answers":"Food_answers__wQqro","answer":"Food_answer__38YSp"};